import { Linking, Platform, View } from 'react-native'
import AppConfig from 'config/AppConfig'
import useAppModes from 'hooks/useAppModes'
import { Back } from 'hooks/useStagesStore'
import { useRemoteConfigStore } from 'hooks/useRemoteConfigStore'
import Page from '@shell/Page'

import IntroDeals from '@screens/intro/deals'
import IntroAvatar from '@screens/intro/avatar'
import IntroTilesSV from '@screens/intro/tiles/IntroTilesSV'
import IntroTilesVF from '@screens/intro/tiles/IntroTilesVF'
import IntroTilesLoading from '@screens/intro/tiles/IntroTilesLoading'

const isWeb = Platform.OS === 'web'
const topLevelBack = AppConfig.launchParams.backTo

export default function IndexPage() {
  const { intro, isAvatar } = useAppModes()
  const config = useRemoteConfigStore((state) => state.config)

  let back: Back = false

  if (topLevelBack) {
    back = () =>
      isWeb
        ? window.location.replace(topLevelBack)
        : Linking.openURL(topLevelBack)
  }

  if (!config) {
    return (
      <Page stage="intro" back={back}>
        <IntroTilesLoading />
      </Page>
    )
  }

  if (intro === 'tiles:sv') {
    return (
      <Page stage="intro" back={back}>
        <IntroTilesSV />
      </Page>
    )
  }

  if (intro === 'tiles:vf') {
    return (
      <Page stage="intro" back={back}>
        <IntroTilesVF />
      </Page>
    )
  }

  return (
    <Page stage="deals" back={back} intro>
      {isAvatar ? <IntroAvatar /> : <IntroDeals />}
    </Page>
  )
}
